class AcceptsEverythingAsserter {
    whenDefined() {
        return this
    }

    matches() {
        return this
    }

    isDefined() {
        return this
    }
}


class Asserter {
    constructor(value) {
        this.value = value
    }

    whenDefined() {
        if (isDefined(this.value)) {
            return this
        }

        return new AcceptsEverythingAsserter()
    }

    matches(matcher, reason = 'The value is not correct') {
        if (typeof matcher.exec === 'function') {
            if (matcher.exec(this.value) === null) {
                throw new Error(reason)
            }
        } else {
            throw new Error('Expected exec function in matcher')
        }
        return this
    }

    isDefined(reason = 'The value must be defined') {
        if (isNotDefined(this.value)) {
            throw new Error(reason)
        }
        return this
    }
}

/**
 * Checks if the provided value is not defined.
 * @param value The value to check
 * @return {boolean} True if value is undefined or null. False if value is defined
 */
const isNotDefined = value => value === null || value === undefined

/**
 * Checks if the provided value is  defined.
 * @param value The value to check
 * @return {boolean} True if value defined. False if value is undefined or null.
 */
const isDefined = value => !isNotDefined(value)

/**
 * Safely return a string from the provided value.
 * @param value The value to get as string.
 * @return {string} Empty string if value is undefined/null, Nan or not a string. A string representation if value is Number ot a non-empty string.
 */
const safeString = value => {
    if (isNotDefined(value)) {
        return ''
    }

    if (typeof value === 'number') {
        return isNaN(value) ? '' : value.toString()
    }

    return typeof value === 'string' ? value : ''
}

const assertThat = value => new Asserter(value)


export {
    isNotDefined,
    isDefined,
    safeString,
    assertThat
}
